import base from './base'

const TRADINGVIEW_STYLE = {
  bg: '#FBFBFB',
  crosshair: '#888888',
  short: '#e24537',
  shortFill: '#e24537',
  long: '#00c087',
  longFill: '#00c087',
  cta: '#FBFBFB',
  ctaHighlight: '#F5F5F5',
  alert: '#FFD506',
  category: 'light',
  grid: '#E6E6E6',
  lineColor: '#555',
  textColor: '#999',
  maLine: '#f0b90b',
  ma1: '#ffc200',
  ma2: '#6600cc',
  ma3: '#cc0066',
}

const tradingViewStyle = TRADINGVIEW_STYLE

export default {
  ...base,
  mode: 'LIGHT',
  exchangeMainBg: '#ececef',
  exchangeSecondBg: '#fff',
  exchangeHeadShadow: 'none',
  exchangeTradePairSearchBg: 'transparent',
  exchangeCommonNumberColor: '#212833',
  exchangeIncrementButtonBorderColor: '#eaecef',
  exchangeMaxAmountBgColor: '#848E9C',
  exchangeMaxAmountColor: '#fff',
  exchangeButtonBorderColor: '#eaecef',
  exchangeButtonHoverBg: 'rgba(240, 185, 11, 0.15)',
  exchangeIconColor: '#959EB1',
  headerBg: '#fff',
  fiatPriceColor: '#333333',
  TxHashColor: '#212833',
  CheckBoxLabelColor: '#48515d',
  thColor: '#d8d8d8',
  qrcodeBg: '#fff',
  exchangeTitleColor: '#48515d',
  headerDropdownBg: '#fff',
  headerDropdownItemHoverBg: '#eaecef',
  headerItemHoverBg: '#eaecef',
  userMenuAddressBg: '#eaecef',
  userMenuAddressTextColor: '#212833',
  dropdownBg: '#fff',
  dropdownItemColor: '#212833',
  dropdownSelectBgColor: 'rgba(234, 236, 239, 0.5)',
  dropdownSelectItemColor: '#48515d',
  dropdownTextDisplayColor: '#fff',
  popupBg: '#fff',
  bg1: '#fff',
  bg2: '#fff',
  inputBgColor: '#fff',
  inputColor: '#212833',
  borderColor: '#DFE2E7',
  selcetItemColor: '#DFE2E7',
  calendarButtonEnable: '#212833',
  calendarButtonDisable: '#48515d',
  greyBg: '#f7f7f7',
  border: '#e6e6e6',
  border1: '#d8d8d8',
  activeBorder: '#f3ba2f',
  boxShadow: '0px 3px 20px 0px rgba(90,102,124,0.2)',
  toolTipBoxShadow: '0 0 12px rgba(0,0,0,.175)',
  activeBg: '#fff9e7',
  boxheadbg: '#f7f7f7',
  tableRowBg: '#fafafa',
  tabBorderColor: '#ddd',
  tabBg: '#fff',
  buttonbg: '#fff',
  chartbuttonbg: '#e6e6e6',
  buttonbgactive: '#f0b90b',
  buttonbgdisabled: '#ddd',
  buttonColorActive: '#f0b90b',
  okButtonBg: '#f0b90b',
  buttonGradient: 'linear-gradient(90deg, rgba(239, 184, 11, 1) 0%, rgba(251, 218, 60, 1) 100%)',
  cancelButtonBg: '#fff',
  up: '#00c087',
  down: '#e24537',
  upLight: '#00c08766',
  downLight: '#e2453766',
  shallowDigitOpacity: 0.45,
  highlight: '#f0b90b',
  chartTheme: 'chart-white2',
  depthTheme: 'depth-white',
  chartDropdownSeparator: '#f4f4f4',
  fontColor: '#212833',
  fontColor2: '#555',
  fontColor3: '#666',
  fontColor4: '#999',
  fontColor5: '#ccc',
  fontColor6: '#fff',
  formsbg: '#f7f7f7',
  inputBorder: '#e2e2e2',
  formsHeaderbg: 'transparent',
  inputBg: '#fff',
  heading: '#262d33',
  miniSymbolsTabActive: 'rgba(253, 242, 216, 0.75)',
  loadingShadeColor: 'rgba(255,255,255,0.3)',
  errorInputBg: '#f7dee0',
  errorInputBorderColor: '#ef4b5a',
  tooltipBg: '#fff',
  counterColor: '#f5bc00',
  bnbBurning: '#e8b342',
  bnbBurnClose: '#aaa',
  buttonPrimaryColor: '#F0B90B',
  xfersLogoBoxBg: '#23448E',
  lineColor: '#f0f0f0',
  sectionBg: '#fff',
  sectionBorderRadius: '4px',
  sectionBoxShadow: '-4px 4px 10px 0px rgba(0,0,0,0.1)',
  radioBg: '#fff',
  buyButtonBg: '#2ebd85',
  sellButtonBg: '#e24537',
  scrollbarBg: '#fbfbfb',
  scrollbarTrackColor: '#fff',
  scrollbarThumbColor: '#d8d8d8',
  tableOddRowBg: '',
  tableRowHoverBg: 'rgba(253,247,236,1)',
  tableRowHoverTextColor: '#212833',
  bestAskBidColor: '#f0b90b',
  bestAskBidDecoration: 'none',
  exchangeSectionTitleColor: '#212833',
  exchangeTabSelectedColor: '#212833',
  exchangeTabSelectedBg: 'transparent',
  exchangeTabSelectedContent: '""',
  exchangeTabNotSelectedColor: '#21283348',
  inputPlaceholderColor: '#eaecef',

  tradingViewStyle,
  tradingViewCssPath: '/static/tradingview/themes/tv-light-theme-v1.min.css',

  tradingViewOverrides: {
    volumePaneSize: 'medium',
    'paneProperties.background': tradingViewStyle.bg,
    'symbolWatermarkProperties.transparency': 85,
    'scalesProperties.backgroundColor': '#151a1e',
    'scalesProperties.textColor': '#555',

    'paneProperties.vertGridProperties.color': tradingViewStyle.grid,
    'paneProperties.horzGridProperties.color': tradingViewStyle.grid,
    'paneProperties.crossHairProperties.color': tradingViewStyle.crosshair,
    'scalesProperties.lineColor': tradingViewStyle.lineColor,
    'symbolWatermarkProperties.color': 'rgba(0, 0, 0, 0)',

    'mainSeriesProperties.style': 1,

    //  Candles styles
    'mainSeriesProperties.candleStyle.upColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.downColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.drawWick': true,
    'mainSeriesProperties.candleStyle.drawBorder': true,
    'mainSeriesProperties.candleStyle.borderColor': '#C400CB',
    'mainSeriesProperties.candleStyle.borderUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.borderDownColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.wickUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.wickDownColor': tradingViewStyle.short,

    'study_Overlay@tv-basicstudies.barStyle.upColor': 'blue',
    'study_Overlay@tv-basicstudies.barStyle.downColor': 'blue',

    'study_Overlay@tv-basicstudies.lineStyle.color': 'blue',

    'study_Overlay@tv-basicstudies.areaStyle.color1': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.color2': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.linecolor': 'blue',
  },
  emergencyNotice: {
    wrapBg: '#212121',
    boxBg: '#3d3d3d',
    dotColor: '#f0b90b',
    titleColor: '#fff',
    detailLinkColor: '#f0b90b',
  },
  FormRow: {
    MaxQuantityBoxBg: '#f3ba2e',
    MaxQuantityBoxColor: '#333',
    FiatPriceBoxBg: 'rgba(38, 38, 38, 1)',
    FiatPriceBoxColor: '#fff',
  },
  Download: {
    bg: '#fff',
  },
  miniSymbolsFiatPrice: {
    bg: 'rgba(38, 38, 38, 1)',
    color: '#fff',
    shadowColor: 'rgba(51,51,51,0.3)',
    linkHoverColor: '#e8b342',
  },
}
